import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from "js-cookie";
import store from '@/store'
import {Dialog} from "vant";

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/LoginView.vue')
    },
    {
        path: '/',
        name: 'main',
        meta: {
            title: '首页',
            keepAlive: true,
        },
        // redirect: '/home',
        // redirect: '/home-yatai',
        redirect: (to) => {
            return store.state.location.homeRedirct ? store.state.location.homeRedirct : '/home'
            // return localStorage.getItem('home-redirct') ? localStorage.getItem('home-redirct') : '/home'
        },
        component: () => import('../views/MainView.vue'),
        children: [
            {
                path: '/home-yatai',//首页是默认子路由，所以为空
                name: 'home-yatai',
                meta: {
                    title: '首页',
                    keepAlive: true,
                },
                component: () => import('@/views/home/HomeViewYaTai.vue')
            },
            {
                path: '/home',//首页是默认子路由，所以为空
                name: 'home',
                meta: {
                    title: '首页',
                    keepAlive: true,
                },
                component: () => import('@/views/home/HomeView.vue')
            },
            {
                path: '/service',
                name: 'service',
                component: () => import('../views/service/SeriveView.vue')
            },
            // {
            //     path: '/service-video-list',
            //     name: 'service-video-list',
            //     component: () => import('../views/service/VideoList.vue')
            // },
            {
                path: '/get-points',
                name: 'get-points',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['../views/point/GetPointsView.vue'], resolve)
                // component: () => import('../views/point/GetPointsView.vue')
            },
            {
                path: '/info',
                name: 'info',
                component: () => import('../views/info/InfoView.vue'),
                // redirect: '/info-volunteer-activity', // 去掉新闻时用
                redirect: '/list-view',
                children: [
                    {
                        path: '/zc-list',
                        name: 'zc-list',
                        component: () => import('../views/info/ZCList.vue')
                    },
                    {
                        path: '/sqgg-list',
                        name: 'sqgg-list',
                        component: () => import('../views/info/SQGGList.vue')
                    },
                    // 志愿风采
                    {
                        path: '/info-volunteer-activity',
                        name: 'info-volunteer-activity',
                        component: () => import('../views/info/InfoVolunteerActivity.vue')
                    },
                    {
                        path: '/list-view',
                        name: 'list-view',
                        component: () => import('../views/info/InfoList.vue')
                    },
                    {
                        path: '/tztg-list',
                        name: 'tztg-list',
                        component: () => import('../views/info/TZTGList.vue')
                    },
                    {
                        path: '/bmzy-view',
                        name: 'bmzy-view',
                        component: () => import('../views/info/BMZYList.vue')
                    },
                    {
                        path: '/info-job',
                        name: 'info-job',
                        component: () => import('../views/info/InfoJobList.vue')
                    }, {
                        path: '/info-enterprising',
                        name: 'info-enterprising',
                        component: () => import('../views/info/InfoEnterprisingList.vue')
                    }, {
                        path: '/info-sale-promotion',
                        name: 'info-sale-promotion',
                        component: () => import('../views/info/InfoSalePromotionList.vue')
                    }
                ]
            },
            {
                path: '/mine',
                name: 'mine',
                meta: {
                    requireAuth: true
                },
                component: resolve => require(['../views/mine/MineView.vue'], resolve)
                // component: () => import('../views/mine/MineView.vue'),
            },
        ]
    },
    {
        path: '/userInfo',
        name: 'UserInfo',
        component: () => import('../views/mine/components/mineUserInfo.vue')
    },
    {
        path: '/feedback',
        name: 'Feedback',
        component: () => import('../views/mine/components/feedback.vue')
    },
    {
        path: '/info-details',
        name: 'info-details',
        component: () => import('../views/info/InfoDetails.vue')
    },
    {
        path: '/take-picture',
        name: 'take-picture',
        redirect: '/take-picture-report',
        component: () => import('../views/home/photograph/TakePictureView.vue'),
        children: [
            {
                path: '/take-picture-report',
                name: 'take-picture-report',
                component: () => import('../views/home/photograph/TakePictureReport.vue')
            },
            {
                path: '/take-picture-history',
                name: 'take-picture-history',
                meta: {
                    title: '上报历史',
                    requireAuth: true
                },
                component: resolve => require(['../views/home/photograph/TakePictureHistory.vue'], resolve),
                // component: () => import('../views/home/photograph/TakePictureHistory.vue')
            },
            {
                path: '/take-picture-comment',
                name: 'take-picture-comment',
                meta: {
                    title: '我的评价',
                    requireAuth: true
                },
                component: resolve => require(['../views/home/photograph/TakePictureCommentList.vue'], resolve),
                // component: () => import('../views/home/photograph/TakePictureCommentList.vue')
            },

        ]
    },
    {
        path: '/report-details',
        name: 'report-details',
        meta: {
            title: '上报详情'
        },
        component: () => import('../views/home/photograph/ReportDetailsView.vue')
    },
    {
        path: '/circumMap',
        name: 'circumMap',
        meta: {
            title: '本地服务'
        },
        component: () => import('@/views/components/circumMap.vue')
    },
    {
        path: '/circum-map-fwdt',
        name: 'circum-map-fwdt',
        meta: {
            title: '服务大厅'
        },
        component: () => import('@/views/components/circumMapFWDT.vue')
    },
    {
        path: '/community-send',
        name: 'community-send',
        meta: {
            title: '社区发布'
        },
        redirect: '/community-send-job',
        component: () => import('@/views/mine/send-community/CommunitySend.vue'),
        children: [
            {
                path: '/community-send-job',
                name: 'community-send-job',
                component: () => import('@/views/mine/send-community/CommunitySendJob.vue')
            },
            {
                path: '/community-send-enterprising',
                name: 'community-send-enterprising',
                component: () => import('@/views/mine/send-community/CommunitySendEnterprising.vue')
            },
            {
                path: '/community-send-hospitalize',
                name: 'community-send-hospitalize',
                component: () => import('@/views/mine/send-community/CommunitySendHospitalize.vue')
            },
            {
                path: '/community-send-volunteer',
                name: 'community-send-volunteer',
                component: () => import('@/views/mine/send-community/CommunitySendVolunteer.vue')
            },
            {
                path: '/community-send-community',
                name: 'community-send-community',
                component: () => import('@/views/mine/send-community/CommunitySendCommunity.vue')
            },
            {
                path: '/community-send-convenience',
                name: 'community-send-convenience',
                component: () => import('@/views/mine/send-community/CommunitySendConvenience.vue')
            },
            {
                path: '/community-send-info',
                name: 'community-send-info',
                component: () => import('@/views/mine/send-community/CommunitySendInfo.vue')
            },
            {
                path: '/community-send-live',
                name: 'community-send-live',
                component: () => import('@/views/mine/send-community/CommunitySendLive.vue')
            }, {
                path: '/community-send-add-goods',
                name: 'community-send-add-goods',
                component: () => import('@/views/mine/send-community/CommunitySendAddGoods.vue')
            }, {
                path: '/community-send-add-merchant',
                name: 'community-send-add-merchant',
                component: () => import('@/views/mine/send-community/CommunitySendMerchant.vue')
            }, {
                path: '/community-send-add-dish',
                name: 'community-send-add-dish',
                component: () => import('@/views/mine/send-community/CommunitySendAddDish.vue')
            }, {
                path: '/community-send-skills-train',
                name: 'community-send-skills-train',
                component: () => import('@/views/mine/send-community/CommunitySendSkillsTrain.vue')
            }, {
                path: '/community-send-xianfeng-classroom',
                name: 'community-send-xianfeng-classroom',
                component: () => import('@/views/mine/send-community/CommunitySendXianFengClassroom.vue')
            },
        ]
    },
    {
        path: '/residents-send',
        name: 'residents-send',
        meta: {
            title: '居民发布'
        },
        redirect: '/residents-send-house',
        component: () => import('@/views/mine/send-residents/ResidentsSend.vue'),
        children: [
            {
                path: '/residents-send-house',
                name: 'residents-send-house',
                component: () => import('@/views/mine/send-residents/ResidentsSendHouse.vue')
            },
            {
                path: '/residents-send-parking',
                name: 'residents-send-parking',
                component: () => import('@/views/mine/send-residents/ResidentsSendParking.vue')
            },
            {
                path: '/residents-send-buy',
                name: 'residents-send-buy',
                component: () => import('@/views/mine/send-residents/ResidentsSendBuy.vue')
            },
            {
                path: '/residents-send-handle',
                name: 'residents-send-handle',
                component: () => import('@/views/mine/send-residents/ResidentsSendHandle.vue')
            },
            {
                path: '/residents-send-merchants',
                name: 'residents-send-merchants',
                component: () => import('@/views/mine/send-residents/ResidentsSendMerchants.vue')
            },
            {
                path: '/residents-send-job',
                name: 'residents-send-job',
                component: () => import('@/views/mine/send-shop/ShopSendJob.vue')
            },
        ]
    },
    {
        path: '/community-service',
        name: 'community-service',
        meta: {
            title: '便民服务'
        },
        redirect: '/community-service-parking',
        component: () => import('@/views/home/community/CommunityService.vue'),
        children: [
            {
                path: '/community-service-parking',
                name: 'community-service-parking',
                component: () => import('@/views/home/community/CommunityServiceParking.vue')
            },
            {
                path: '/community-service-house',
                name: 'community-service-house',
                component: () => import('@/views/home/community/CommunityServiceHouse.vue')
            },
            {
                path: '/community-service-restaurant',
                name: 'community-service-restaurant',
                component: () => import('@/views/home/community/CommunityServiceRestaurant.vue')
            },
            {
                path: '/community-service-convenience',
                name: 'community-service-convenience',
                component: () => import('@/views/home/community/CommunityServiceConvenience.vue')
            },
            {
                path: '/community-service-activity',
                name: 'community-service-activity',
                component: () => import('@/views/home/community/CommunityServiceActivity.vue')
            },
            {
                path: '/community-service-consultation',
                name: 'community-service-consultation',
                component: () => import('@/views/home/community/CommunityServiceConsultation.vue')
            },
            // 明湖 社团列表
            {
                path: '/community-service-corporation',
                name: 'community-service-corporation',
                component: () => import('../views/home/community/CommunityServiceCorporation.vue')
            },
            // 明湖亚太 社会组织列表
            {
                path: '/community-service-social-organization',
                name: 'community-service-social-organization',
                component: () => import('../views/home/community/CommunityServiceSocialOrganization.vue')
            },
            // 明湖 志愿者服务队
            {
                path: '/community-service-volunteer-team',
                name: 'community-service-volunteer-team',
                component: () => import('../views/home/community/CommunityServiceVolunteerTeam.vue')
            }
        ]
    },
    {
        path: '/earn-points',
        name: 'earn-points',
        meta: {
            title: '赚积分',
            requireAuth: true
        },
        redirect: '/earn-points-community',
        component: resolve => require(['@/views/point/EarnPointsMore.vue'], resolve),
        // component: () => import('@/views/point/EarnPointsMore.vue'),
        children: [
            {
                path: '/earn-points-community',
                name: 'earn-points-community',
                meta: {
                    title: '文化活动',
                },
                component: () => import('@/views/point/EarnPointsCommunityActivity.vue')
            },
            {
                path: '/earn-points-volunteer',
                name: 'earn-points-volunteer',
                component: () => import('@/views/point/EarnPointsVolunteer.vue')
            },
            {
                path: '/earn-points-buy',
                name: 'earn-points-buy',
                component: () => import('@/views/point/EarnPointsBuy.vue')
            },
            {
                path: '/earn-points-handle',
                name: 'earn-points-handle',
                component: () => import('@/views/point/EarnPointsHandle.vue')
            },
            {
                path: '/earn-points-xianfeng',
                name: 'earn-points-xianfeng',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildStudy.vue'], resolve),
                component: () => import('@/views/point/EarnPointsXianFengClassRoom.vue')
            },
            {
                path: '/earn-points-gonghui-vip',
                name: 'earn-points-gonghui-vip',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildStudy.vue'], resolve),
                component: () => import('@/views/point/EarnPointsGongHuiVip.vue')
            },
        ]
    }, {
        path: '/my-send',
        name: 'my-send',
        meta: {
            title: '我发布的记录'
        },
        // redirect: '/send-mine-house',
        redirect: to => {
            console.log('重定向' + to)
            let userStatus = Cookies.get('X-Client-Type')
            console.log('userStatus' + userStatus)
            if (userStatus == 'app-resident') {
                // 房屋
                return '/send-mine-house'
            } else if (userStatus == 'app-community') {
                // 便民服务
                return '/send-mine-convenience'
            }
                // else if (store.state.user.userInfo.shopStatus == '1') {
                //     // 优惠活动
                //     return '/send-mine-house'
            // }
            else {
                //内容用户权限管理
                return '/send-mine-house'
            }
        },
        component: () => import('@/views/mine/send-mine/SendMineView.vue'),
        children: [
            {
                path: '/send-mine-house',
                name: 'send-mine-house',
                component: () => import('@/views/mine/send-mine/SendHouse.vue')
            },
            {
                path: '/send-mine-parking',
                name: 'send-mine-parking',
                component: () => import('@/views/mine/send-mine/SendParking.vue')
            },
            {
                path: '/send-mine-buy',
                name: 'send-mine-buy',
                component: () => import('@/views/mine/send-mine/SendBuy.vue')
            },
            {
                path: '/send-mine-handle',
                name: 'send-mine-handle',
                component: () => import('@/views/mine/send-mine/SendHandle.vue')
            },
            {
                path: '/send-mine-corporation',
                name: 'send-mine-corporation',
                component: () => import('@/views/mine/send-mine/SendCorporation.vue')
            },
            {
                path: '/send-mine-community-activity',
                name: 'send-mine-community-activity',
                component: () => import('@/views/mine/send-mine/SendCommunityActivityList.vue')
            },
            {
                path: '/send-mine-volunteer-activity',
                name: 'send-mine-volunteer-activity',
                component: () => import('@/views/mine/send-mine/SendVolunteerActivityList.vue')
            },
            {
                path: '/send-mine-convenience',
                name: 'send-mine-convenience',
                component: () => import('@/views/mine/send-mine/SendMineConvenience.vue')
            },
            {
                path: '/send-mine-info',
                name: 'send-mine-info',
                component: () => import('@/views/mine/send-mine/SendMineInfo.vue'),
                meta: {
                    title: '资讯'
                },
                redirect: '/send-mine-zc-list',
                children: [
                    {
                        path: '/send-mine-zc-list',
                        name: 'send-mine-zc-list',
                        component: () => import('../views/mine/send-mine/send-mine-info/ZCList.vue')
                    },
                    {
                        path: '/send-mine-sqgg-list',
                        name: 'send-mine-sqgg-list',
                        component: () => import('../views/mine/send-mine/send-mine-info/SQGGList.vue')
                    },
                    // 志愿风采
                    {
                        path: '/send-mine-info-volunteer-activity',
                        name: 'send-mine-info-volunteer-activity',
                        component: () => import('../views/mine/send-mine/send-mine-info/InfoVolunteerActivity.vue')
                    },
                    {
                        path: '/send-mine-list-view',
                        name: 'send-mine-list-view',
                        component: () => import('../views/mine/send-mine/send-mine-info/InfoList.vue')
                    },
                    {
                        path: '/send-mine-tztg-list',
                        name: 'send-mine-tztg-list',
                        component: () => import('../views/mine/send-mine/send-mine-info/TZTGList.vue')
                    },
                    {
                        path: '/send-mine-bmzy-view',
                        name: 'send-mine-bmzy-view',
                        component: () => import('../views/mine/send-mine/send-mine-info/BMZYList.vue')
                    },
                    {
                        path: '/send-mine-info-job',
                        name: 'send-mine-info-job',
                        component: () => import('../views/mine/send-mine/send-mine-info/InfoJobList.vue')
                    }, {
                        path: '/send-mine-info-enterprising',
                        name: 'send-mine-info-enterprising',
                        component: () => import('../views/mine/send-mine/send-mine-info/InfoEnterprisingList.vue')
                    }, {
                        path: '/send-mine-info-sale-promotion',
                        name: 'send-mine-info-sale-promotion',
                        component: () => import('../views/mine/send-mine/send-mine-info/InfoSalePromotionList.vue')
                    }
                ],
            },
            // 就医 咨询
            {
                path: '/send-mine-service-consultation',
                name: 'send-mine-service-consultation',
                component: () => import('@/views/mine/send-mine/SendMineServiceConsultation.vue')
            },
            {
                path: '/send-mine-dish',
                name: 'send-mine-dish',
                component: () => import('@/views/mine/send-mine/SendMineDish.vue')
            },
            {
                path: '/send-mine-goods',
                name: 'send-mine-goods',
                component: () => import('@/views/mine/send-mine/SendExchangeGoods.vue')
            },
            {
                path: '/send-mine-skills-train',
                name: 'send-mine-skills-train',
                component: () => import('../views/mine/send-mine/SendMineSkillsTrain.vue')
            },
            {
                path: '/shop-send-mine-job',
                name: 'shop-send-mine-job',
                component: () => import('../views/mine/send-shop/ShopSendMineJobList.vue')
            }
        ]
    }, {
        path: '/party-build',
        name: 'party-build',
        meta: {
            title: '党建引领'
        },
        redirect: '/party-build-xianfeng',
        component: () => import('@/views/home/dangjian/PartyBuildView.vue'),
        children: [
            {
                path: '/party-build-xianfeng',
                name: 'party-build-xianfeng',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildStudy.vue'], resolve),
                component: () => import('@/views/home/yatai/XianFengClassRoom.vue')
            },
            {
                path: '/party-build-study',
                name: 'party-build-study',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildStudy.vue'], resolve),
                component: () => import('@/views/home/dangjian/PartyBuildStudy.vue')
            },
            {
                path: '/party-build-convenience',
                name: 'party-build-convenience',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildConvenience.vue'], resolve),
                component: () => import('@/views/home/dangjian/PartyBuildConvenience.vue')
            }, {
                path: '/party-build-regist',
                name: 'party-build-regist',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildRegist.vue'], resolve),
                component: () => import('@/views/home/dangjian/PartyBuildRegist.vue')
            }, {
                path: '/party-build-organization',
                name: 'party-build-organization',
                // meta: {
                //     requireAuth: true,
                // },
                // component: resolve => require(['@/views/home/dangjian/PartyBuildOrganization.vue'], resolve),
                component: () => import('@/views/home/dangjian/PartyBuildOrganization.vue')
            },
        ]
    }, {
        path: '/review-apply',
        name: 'review-apply',
        meta: {
            title: '我需要审核的'
        },
        redirect: '/review-send-mine-residents',
        component: () => import('@/views/mine/review/ReviewApply.vue'),
        children: [
            {
                path: '/review-send-mine-residents',
                name: 'review-send-mine-residents',
                component: () => import('@/views/mine/review/ReviewResidents.vue')
            },
            {
                path: '/review-send-mine-weiwangge',
                name: 'review-send-mine-weiwangge',
                component: () => import('@/views/mine/review/ReviewWeiWangeGe.vue')
            },
            {
                path: '/review-merchant-apply',
                name: 'review-merchant-apply',
                component: () => import('@/views/mine/review/ReviewMerchantApply.vue')
            },
            {
                path: '/review-party-members',
                name: 'review-party-members',
                component: () => import('@/views/mine/review/ReviewPartyMembers.vue')
            },
            {
                path: '/review-car-park',
                name: 'review-car-park',
                component: () => import('@/views/mine/review/ReviewCarPark.vue')
            },
            {
                path: '/review-house-rent',
                name: 'review-house-rent',
                component: () => import('@/views/mine/review/ReviewHouseRent.vue')
            },
            {
                path: '/review-instead-buy',
                name: 'review-instead-buy',
                component: () => import('@/views/mine/review/ReviewInsteadBuy.vue')
            },
            {
                path: '/review-instead-handle',
                name: 'review-instead-handle',
                component: () => import('@/views/mine/review/ReviewInsteadHandle.vue')
            },
            {
                path: '/review-exchange',
                name: 'review-exchange',
                component: () => import('@/views/mine/review/ReviewExchange.vue')
            },
            {
                path: '/review-shop-send-job',
                name: 'review-shop-send-job',
                component: () => import('@/views/mine/review/ReviewShopSendJob.vue')
            },
        ]
    },
    {
        path: '/review-apply-resident',
        name: 'review-apply-resident',
        meta: {
            title: '我需要审核的'
        },
        redirect: '/review-send-mine-social-corporation',
        component: () => import('@/views/mine/review/ReviewApplyResident.vue'),
        children: [
            {
                path: '/review-send-mine-social-corporation',
                name: 'review-send-mine-social-corporation',
                component: () => import('@/views/mine/review/ReviewCorporationApply.vue')
            },
        ]
    },
    // 商家发布
    {
        path: '/merchant-send',
        name: 'merchant-send',
        meta: {
            title: '商家发布'
        },
        redirect: '/merchant-send-sale-promotion',
        component: () => import('../views/mine/merchant/MerchantSend.vue'),
        children: [
            {
                path: '/merchant-send-sale-promotion',
                name: 'merchant-send-sale-promotion',
                component: () => import('../views/mine/merchant/MerchantSendSalePromotion.vue')
            }
        ]
    },
    {
        path: '/restaurant-details',
        name: 'restaurant-details',
        meta: {
            title: '餐厅详情',
            requireAuth: false,
        },
        component: resolve => require(['@/views/home/community/restaurant/CommunityServiceRestaurantDetails.vue'], resolve),
        // component: () => import('@/views/home/community/restaurant/CommunityServiceRestaurantDetails.vue'),
    }, {
        path: '/my-booking-dish',
        name: 'my-booking-dish',
        meta: {
            title: '我预约的点餐'
        },
        component: () => import('@/views/mine/MyBookingDish.vue'),
    },
    {
        path: '/restaurantRreservation',
        name: 'RestaurantRreservation',
        meta: {
            title: '预约完成'
        },
        component: () => import('@/views/home/community/restaurant/restaurantRreservationDetails.vue'),
    }, {
        path: '/house-details',
        name: 'house-details',
        meta: {
            title: '我发布的房源详情'
        },
        component: () => import('@/views/mine/send-mine/DetailsSendHouse.vue'),
    }, {
        path: '/point-exchange',
        name: 'point-exchange',
        meta: {
            title: '积分兑换',
        },
        component: () => import('@/views/exchange/PointExchangeList.vue'),
    },
    {
        path: '/point-exchange-details',
        name: 'point-exchange-details',
        meta: {
            title: '积分兑换',
            requireAuth: true,
        },
        component: resolve => require(['@/views/exchange/PointExchangeGoodesDetails.vue'], resolve)
        // component: () => import('@/views/home/point/PointExchangeGoodesDetails.vue'),
    },
    {
        path: '/exchange-goods-submit',
        name: 'exchange-goods-submit',
        meta: {
            title: '积分兑换',
            requireAuth: true,
        },
        component: resolve => require(['@/views/exchange/ExchangeSubmit.vue'], resolve)
        // component: () => import('@/views/home/point/PointExchangeGoodesDetails.vue'),
    },
    {
        path: '/exchange-gonghui-goods-submit',
        name: 'exchange-gonghui-goods-submit',
        meta: {
            title: '工会积分兑换',
            requireAuth: true,
        },
        component: resolve => require(['@/views/exchange/ExchangeGongHuiSubmit.vue'], resolve)
        // component: () => import('@/views/home/point/PointExchangeGoodesDetails.vue'),
    },
    {
        path: '/edit-receive-address',
        name: 'edit-receive-address',
        meta: {
            title: '编辑地址',
            requireAuth: true,
        },
        component: resolve => require(['@/views/exchange/EditReceiveAddress.vue'], resolve)
        // component: () => import('@/views/home/point/PointExchangeGoodesDetails.vue'),
    },
    {
        path: '/receive-address-list',
        name: 'receive-address-list',
        meta: {
            title: '地址列表',
            requireAuth: true,
        },
        component: resolve => require(['@/views/exchange/ReceiveAddressList.vue'], resolve)
        // component: () => import('@/views/home/point/PointExchangeGoodesDetails.vue'),
    },
    {
        path: '/handle-take-picture',
        name: 'handle-take-picture',
        redirect: '/handle-take-picture-wait',
        component: () => import('../views/mine/photo/HandleTakePicture.vue'),
        children: [
            {
                path: '/handle-take-picture-wait',
                name: 'handle-take-picture-wait',
                component: () => import('../views/mine/photo/HandleTakePictureWait.vue')
            },
            {
                path: '/handle-take-picture-processing',
                name: 'handle-take-picture-processing',
                component: () => import('../views/mine/photo/HandleTakePictureProcessing.vue')
            },
            {
                path: '/handle-take-picture-complete',
                name: 'handle-take-picture-complete',
                component: () => import('../views/mine/photo/HandleTakePictureComplete.vue')
            },
            {
                path: '/handle-take-picture-comment',
                name: 'handle-take-picture-comment',
                component: () => import('../views/mine/photo/HandleTakePictureComment.vue')
            },
        ]
    },
    {
        path: '/point-rules',
        name: 'point-rules',
        component: () => import('../views/point/PointRules.vue')
    },
    {
        path: '/point-records',
        name: 'point-records',
        meta: {
            requireAuth: true
        },
        component: resolve => require(['../views/point/PointRecords.vue'], resolve)
        // component: () => import('../views/point/PointRecords.vue')
    },
    {
        path: '/point-exchange-records',
        name: 'point-exchange-records',
        meta: {
            requireAuth: true
        },
        component: resolve => require(['../views/exchange/PointExchangeRecordsList.vue'], resolve)
        // component: () => import('../views/point/PointRecords.vue')
    },
    // 活动详情
    {
        path: '/activity-details',
        name: 'activity-details',
        // meta: {
        //     requireAuth: true
        // },
        // component: resolve => require(['../views/home/community/ActivityDetailsView.vue'], resolve)
        component: () => import('../views/home/community/ActivityDetailsView.vue')
    },
    // 工会活动详情
    {
        path: '/gonghui-activity-details',
        name: 'gonghui-activity-details',
        // meta: {
        //     requireAuth: true
        // },
        component: () => import('../views/point/GongHuiActivityDetailsView.vue')
    },
    // 我参与的活动
    {
        path: '/activity-participate',
        name: 'activity-participate',
        redirect: '/activity-participate-community',
        component: () => import('../views/mine/activity/ActiviyParticipate.vue'),
        children: [
            {
                path: '/activity-participate-community',
                name: 'activity-participate-community',
                component: () => import('../views/mine/activity/ActivityParticipateCommunity.vue')
            },
            {
                path: '/activity-participate-volunteer',
                name: 'activity-participate-volunteer',
                component: () => import('../views/mine/activity/ActivityParticipateVolunteer.vue')
            },
            {
                path: '/activity-participate-gonghui',
                name: 'activity-participate-gonghui',
                component: () => import('../views/mine/activity/ActivityParticipateGonghui.vue')
            },
            {
                path: '/mine-lkgs',
                name: 'mine-lkgs',
                component: () => import('../views/mine/lkgs/MineLkGS.vue')
            }
        ]
    },
    // 订单详情
    {
        path: '/order-details',
        name: 'order-details',
        component: () => import('../views/exchange/PointExchangeDetails.vue')
    },
    // 聊天界面
    {
        path: '/chat-view',
        name: 'chat-view',
        component: () => import('../views/components/chatView.vue')
    },
    // 聊天列表
    {
        path: '/message-list-view',
        name: 'message-list-view',
        component: () => import('../views/mine/message/MessageListView.vue')
    },
    // 党员报到详情
    {
        path: '/details-review-party',
        name: 'details-review-party',
        component: () => import('../views/mine/review/DetailsReviewParty.vue')
    },
    // 社区审核的 车位详情
    {
        path: '/details-review-car-park',
        name: 'details-review-car-park',
        component: () => import('../views/mine/review/DetailsReviewCarPark.vue')
    },
    // 我发布的 车位详情
    {
        path: '/details-send-car-park',
        name: 'details-send-car-park',
        component: () => import('../views/mine/send-mine/DetailsSendCarPark.vue')
    },
    // 社区审核的 房源详情
    {
        path: '/details-review-house-rent',
        name: 'details-review-house-rent',
        component: () => import('../views/mine/review/DetailsReviewHouseRent.vue')
    },
    // 社区审核的 代买详情
    {
        path: '/details-review-instead-buy',
        name: 'details-review-instead-buy',
        component: () => import('../views/mine/review/DetailsReviewInsteadBuy.vue')
    },
    // 社区审核的 代办详情
    {
        path: '/details-review-instead-handle',
        name: 'details-review-instead-handle',
        component: () => import('../views/mine/review/DetailsReviewInsteadHandle.vue')
    },
    // 社区审核的 商家入驻详情
    {
        path: '/details-review-merchant-apply',
        name: 'details-review-merchant-apply',
        component: () => import('../views/mine/review/DetailsReviewMerchantApply.vue')
    },

    // 社区发布的 活动详情
    {
        path: '/details-send-mine-activity',
        name: 'details-send-mine-activity',
        component: () => import('../views/mine/send-mine/DetailsSendActivity.vue')
    },
    // 社区发布的 志愿者活动详情
    {
        path: '/details-send-mine-activity-volunteer',
        name: 'details-send-mine-activity-volunteer',
        component: () => import('../views/mine/send-mine/DetailsSendActivityVolunteer.vue')
    },

    // 商家入驻
    {
        path: '/merchant-apply',
        name: 'merchant-apply',
        meta: {
            requireAuth: true
        },
        component: resolve => require(['../views/mine/merchant/MerchantApply.vue'], resolve)
        // component: () => import('../views/mine/merchant/MerchantApply.vue')
    },
    // 商家促销活动详情
    {
        path: '/info-details-sale-promotion',
        name: 'info-details-sale-promotion',
        component: () => import('../views/info/InfoSalePromotionDetails.vue')
    },
    // 便民服务红色物业详情
    {
        path: '/details-send-mine-wy',
        name: 'details-send-mine-wy',
        component: () => import('../views/mine/send-mine/DetailsSendWy.vue')
    },
    // 便民服务红色驿站详情
    {
        path: '/details-send-mine-yz',
        name: 'details-send-mine-yz',
        component: () => import('../views/mine/send-mine/DetailsSendYz.vue')
    },
    // 便民服务办证详情
    {
        path: '/details-send-mine-bz',
        name: 'details-send-mine-bz',
        component: () => import('../views/mine/send-mine/DetailsSendBz.vue')
    },
    // 资讯 详情
    {
        path: '/details-send-mine-info',
        name: 'details-send-mine-info',
        component: () => import('../views/mine/send-mine/DetailsSendInfo.vue')
    },
    // 菜品 详情
    {
        path: '/details-send-mine-dish',
        name: 'details-send-mine-dish',
        component: () => import('../views/mine/send-mine/DetailsSendDish.vue')
    },
    // 就业 详情
    {
        path: '/details-send-mine-job',
        name: 'details-send-mine-job',
        component: () => import('../views/mine/send-mine/DetailsSendJob.vue')
    },
    // 就业 详情 新
    {
        path: '/details-send-mine-jh-job',
        name: 'details-send-mine-jh-job',
        component: () => import('../views/mine/send-mine/DetailsSendJHJob.vue')
    },
    // 技能培训列表
    {
        path: '/skills-train-list',
        name: 'skills-train-list',
        component: () => import('../views/home/jinghang/SkillsTrainList.vue')
    },
    // 技能培训详情
    {
        path: '/details-skills-train',
        name: 'details-skills-train',
        component: () => import('../views/home/jinghang/DetailSkillsTrain.vue')
    },
    // 创业 详情
    {
        path: '/details-send-mine-enterprising',
        name: 'details-send-mine-enterprising',
        component: () => import('../views/mine/send-mine/DetailsSendEnterprising.vue')
    },
    // 我发布的->商品详情
    {
        path: '/details-send-mine-goods',
        name: 'details-send-mine-goods',
        component: () => import('../views/mine/send-mine/DetailsSendGoods.vue')
    },

    // 管理端
    {
        path: '/admin',
        name: 'admin',
        component: () => import('../views/admin/AdminView.vue')
    },
    // 单独的礼品核销
    {
        path: '/review-exchange-admin',
        name: 'review-exchange-admin',
        component: () => import('../views/admin/ReviewExchangeAdmin.vue')
    },
    // 党支部 详情
    {
        path: '/party-branch-details',
        name: 'party-branch-details',
        component: () => import('../views/home/dangjian/PartyBranchDetails.vue')
    },
    // 党群服务中心 详情
    {
        path: '/party-group-details',
        name: 'party-group-details',
        component: () => import('../views/home/dangjian/PartyGroupDetails.vue')
    },
    // 空白页
    {
        path: '/blank-view',
        name: 'blank-view',
        component: () => import('../views/admin/BlankView.vue')
    },
    // 党员学习详情
    {
        path: '/details-party-study',
        name: 'details-party-study',
        component: () => import('../views/home/dangjian/DetailsPartyStudy.vue')
    },
    // 社团详情
    {
        path: '/details-corporation',
        name: 'details-corporation',
        component: () => import('../views/home/community/DetailsCorporation.vue')
    },
    // 志愿服务队详情
    {
        path: '/details-volunteer-team',
        name: 'details-volunteer-team',
        component: () => import('../views/home/community/DetailsVolunteerTeam.vue')
    },
    // v积分上报
    {
        path: '/v-point-report',
        name: 'v-point-report',
        component: () => import('../views/mine/micro-grid/VPointReport.vue')
    },
    // v积分排名
    {
        path: '/v-point-rank',
        name: 'v-point-rank',
        component: () => import('../views/mine/VRankView.vue')
    },
    // 找工作列表详情
    {
        path: '/details-jh-job',
        name: 'details-jh-job',
        component: () => import('../views/home/jinghang/DetailsJHJob.vue')
    },
    // 找工作列表
    {
        path: '/job-jh-list',
        name: 'job-jh-list',
        component: () => import('../views/home/jinghang/JobFindList.vue')
    },
    // 审核商家发布工作详情
    {
        path: '/details-review-shop-job',
        name: 'details-review-shop-job',
        component: () => import('../views/mine/review/DetailsReviewShopJob.vue')
    },
    // 我发布的技能培训详情
    {
        path: '/details-send-mine-skill-train',
        name: 'details-send-mine-skill-train',
        component: () => import('../views/mine/send-mine/DetailSendSkillsTrain.vue')
    },
    // 学校详情
    {
        path: '/details-school',
        name: 'details-school',
        component: () => import('../views/home/school/DetailSchool.vue')
    },
    // 微网格上报
    {
        path: '/micro-grid-event-report',
        name: 'micro-grid-event-report',
        component: () => import('../views/home/microgrid/MicroGridEventReport.vue')
    },
    // 我发布的代买详情
    {
        path: '/details-send-buy',
        name: 'details-send-buy',
        component: () => import('../views/mine/send-mine/DetailsSendBuy.vue')
    },
    // 我发布的代办详情
    {
        path: '/details-send-handle',
        name: 'details-send-handle',
        component: () => import('../views/mine/send-mine/DetailsSendHandle.vue')
    },
    // 群众诉求
    {
        path: '/mass-demand',
        name: 'mass-demand',
        component: () => import('../views/home/yatai/MassDemands.vue')
    },
    // 公益良酷公设
    {
        path: '/gy-lkgs',
        name: 'gy-lkgs',
        component: () => import('../views/home/yatai/LiangKuGongShe.vue')
    },
    // 先锋课堂详情
    {
        path: '/xianfeng-classroom-details',
        name: 'xianfeng-classroom-details',
        component: () => import('../views/home/yatai/XianFengClassrommDetails.vue')
    },
    // // 申请创建组织
    // {
    //     path: '/corporation-apply',
    //     name: 'corporation-apply',
    //     component: () => import('../views/home/yatai/CorporationApply.vue')
    // },
    // 我发布的组织详情
    {
        path: '/details-send-mine-corporation',
        name: 'details-send-mine-corporation',
        component: () => import('../views/mine/send-mine/DetailsSendCorporation.vue')
    },
    // 我审核的的组织详情
    {
        path: '/details-review-social-corporation',
        name: 'details-review-social-corporation',
        component: () => import('../views/mine/review/DetailsReviewCorporation.vue')
    },
    // 招牌备案
    {
        path: '/guanggao-zhaopai',
        name: 'guanggao-zhaopai',
        meta: {
            title: '招牌备案',
            requireAuth: true,
        },
        component: () => import('../views/home/zp-beian/GuangGaoZhaoPai.vue')
    },
    // 我要备案
    {
        path: '/my-ggba-apply',
        name: 'my-ggba-apply',
        component: () => import('../views/home/zp-beian/SubmitGGBABasic.vue')
    },
    // 所需资料
    {
        path: '/require-infomation',
        name: 'require-infomation',
        component: () => import('../views/home/zp-beian/RequireInfomation.vue')
    },
    // 招牌设置规范
    {
        path: '/set-specifications',
        name: 'set-specifications',
        component: () => import('../views/home/zp-beian/SetSpecifications.vue')
    },
    // 参考图例
    {
        path: '/reference-legend',
        name: 'reference-legend',
        component: () => import('../views/home/zp-beian/ReferenceLegend.vue')
    },
    // 提交资料
    {
        path: '/submit-info',
        name: 'submit-info',
        component: () => import('../views/home/zp-beian/SubmitInfo.vue')
    },
    // 提交承诺书
    {
        path: '/submit-promise',
        name: 'submit-promise',
        component: () => import('../views/home/zp-beian/SubmitPromise.vue')
    },
    // 我的招牌
    {
        path: '/my-zpba-list',
        name: 'my-zpba-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('../views/home/zp-beian/MyZPBAList.vue'),
        children: []
    },
    // 潮河办事处相关
    // 养老服务
    {
        path: '/pension-service',
        name: 'pension-service',
        component: () => import('../views/home/chaohe/PensionService.vue')
    },
    // 养老服务 - 机构简介
    {
        path: '/organization-introduction',
        name: 'organization-introduction',
        component: () => import('../views/home/chaohe/PensionOrgIntroduction.vue')
    },
    // 养老服务 - 组织架构
    {
        path: '/organization-structure',
        name: 'organization-structure',
        component: () => import('../views/home/chaohe/OrganizationalStructure.vue')
    },
    // 养老服务 - 团队展示
    {
        path: '/pension-team-list',
        name: 'pension-team-list',
        component: () => import('../views/home/chaohe/PensionTeamList.vue')
    },
    // 养老服务 - 活动
    {
        path: '/pension-activity-list',
        name: 'pension-activity-list',
        component: () => import('../views/home/chaohe/PensionActivityList.vue')
    },
    // 养老服务 - 活动详情
    {
        path: '/pension-activity-details',
        name: 'pension-activity-details',
        component: () => import('../views/home/chaohe/PensionActivityDetails.vue')
    },
    // 托育 - 首页
    {
        path: '/childcare',
        name: 'childcare',
        component: () => import('../views/home/chaohe/ChildCare.vue')
    },
    // 托育 - 机构简介
    {
        path: '/childcare-org-introduction',
        name: 'childcare-org-introduction',
        component: () => import('../views/home/chaohe/ChildCareOrgIntroduction.vue')
    },
    // 托育 - 组织架构
    {
        path: '/organization-structure-childcare',
        name: 'organization-structure-childcare',
        component: () => import('../views/home/chaohe/OrganizationalStructureChildCare.vue')
    },
    // 服务 - 服务详情
    {
        path: '/service-details',
        name: 'service-details',
        component: () => import('../views/home/chaohe/ServiceDetails.vue')
    },

    // 营商环境 h5
    {
        path: '/company-service',
        name: 'company-service',
        meta: {
            keepAlive: true,
            requireAuth: true,
        },
        redirect: '/company-service-zccx',
        component: () => import('../views/home/yingshang/CompanyService.vue'),
        children: [
            {
                path: '/company-service-zccx',
                name: 'company-service-zccx',
                meta: {
                    keepAlive: true
                },
                component: () => import('../views/home/yingshang/CompanyServiceZCCX.vue')
            },
            {
                path: '/company-service-scpp',
                name: 'company-service-scpp',
                meta: {
                    keepAlive: true
                },
                component: () => import('../views/home/yingshang/CompanyServiceZCPP.vue')
            },
            {
                path: '/company-service-scpp-new',
                name: 'company-service-scpp-new',
                meta: {
                    keepAlive: true
                },
                component: () => import('../views/home/yingshang/CompanyServiceZCPPNew.vue')
            },
            {
                path: '/company-service-fbzp',
                name: 'company-service-fbzp',
                component: () => import('../views/home/yingshang/CompanyServiceFBZP.vue')
            },
            {
                path: '/ys-login',
                name: 'ys-login',
                component: () => import('../views/home/yingshang/YsLogin.vue')
            },
            {
                path: '/company-service-zsk',
                name: 'company-service-zsk',
                component: () => import('../views/home/yingshang/CompanyServiceZSK.vue')
            },
            {
                path: '/company-appeal',
                name: 'company-appeal',
                component: () => import( '../views/home/yingshang/CompanyAppeal.vue'),
                // component: () => import( '../views/home/yingshang/YsHome.vue'),
            },
        ],
    },
    {
        path: '/ys-home',
        name: 'ys-home',
        component: () => import( '../views/home/yingshang/YsHome.vue'),
    },
    {
        path: '/ys-home-new',
        name: 'ys-home-new',
        component: () => import( '../views/home/yingshang/YsHomeNew.vue'),
        // component: () => import( '../views/home/yingshang/YsHome.vue'),
    },
    {
        path: '/old-appeal',
        name: 'old-appeal',
        component: () => import( '../views/home/yingshang/OldAppeal.vue'),
        // component: () => import( '../views/home/yingshang/YsHome.vue'),
    },
    {
        path: '/comment-appeal',
        name: 'comment-appeal',
        component: () => import( '../views/home/yingshang/CommentAppeal.vue'),
        // component: () => import( '../views/home/yingshang/YsHome.vue'),
    },
    {
        path: '/ys-details',
        name: 'ys-details',
        component: () => import('../views/home/yingshang/mineDetails.vue')
    },
    {
        path: '/MessageReply',
        name: 'MessageReply',
        component: () => import('../views/home/yingshang/MessageReply.vue')
    },
    {
        path: '/bind-company',
        name: 'bind-company',
        component: () => import('../views/home/yingshang/BindCompany.vue')
    },
    {
        path: '/match-calibration',
        name: 'match-calibration',
        component: () => import('../views/home/yingshang/MatchCalibration.vue')
    },
    {
        path: '/zc-details',
        name: 'zc-details',
        component: () => import('../views/home/yingshang/ZCDetails.vue')
    },
    {
        path: '/zccx-details',
        name: 'zccx-details',
        component: () => import('../views/home/yingshang/ZCCXDetails.vue')
    },
    {
        path: '/zccx-details-template',
        name: 'zccx-details-template',
        component: () => import('../views/home/yingshang/ZCCXDetailsTemplate.vue')
    },
    {
        path: '/no-match-list',
        name: 'no-match-list',
        component: () => import('../views/home/yingshang/NoMatchList.vue')
    },
    // 百姓城管
    {
        path: '/people-city-management',
        name: 'people-city-management',
        component: () => import('../views/home/citymanagement/CityManagement.vue')
    },
    // 科普服务及答疑
    {
        path: '/science-and-answer',
        name: 'science-and-answer',
        component: () => import('../views/home/yingshang/knowledge/ScienceAndAnswer.vue'),
        redirect: '/zsk-conception',
        children: [
            {
                path: '/zsk-conception',
                name: 'zsk-conception',
                meta: {
                    // keepAlive: true
                },
                component: () => import('../views/home/yingshang/knowledge/ZskConception.vue')
            },
            {
                path: '/zsk-policy',
                name: 'zsk-policy',
                meta: {
                    // keepAlive: true
                },
                component: () => import('../views/home/yingshang/knowledge/ZskPolicy.vue')
            },
            {
                path: '/zsk-specification',
                name: 'zsk-specification',
                meta: {
                    // keepAlive: true
                },
                component: () => import('../views/home/yingshang/knowledge/ZskSpecification.vue')
            },
            {
                path: '/zsk-method',
                name: 'zsk-method',
                meta: {
                    // keepAlive: true
                },
                component: () => import('../views/home/yingshang/knowledge/ZskMethod.vue')
            },
        ],
    },
    // 在线视频学习
    {
        path: '/zsk-online-video',
        name: 'zsk-online-video',
        component: () => import('../views/home/yingshang/knowledge/OnlineVideo.vue')
    },
    // 服务数字播报视频列表
    {
        path: '/service-video-list',
        name: 'service-video-list',
        component: () => import('../views/service/VideoList.vue')
    },
    // 招聘
    {
        path: '/recruit-view',
        name: 'recruit-view',
        meta: {
            keepAlive: true
        },
        component: () => import('../views/home/recruit/RecruitView.vue')
    },
    // 列表
    {
        path: '/recruit-list',
        name: 'recruit-list',
        meta: {
            keepAlive: true
        },
        component: () => import('../views/home/recruit/RecruitList.vue')
    },
    // 详情
    {
        path: '/recruit-details',
        name: 'recruit-details',
        meta: {
            keepAlive: true
        },
        component: () => import('../views/home/recruit/RecruitDetails.vue')
    },
    // 招聘会详情
    {
        path: '/zhaopinhui-details',
        name: 'zhaopinhui-details',
        meta: {
            keepAlive: true
        },
        component: () => import('../views/home/recruit/ZhaopinhuiDetails.vue')
    },
    //  百姓城管 -> 道路挖掘 -------------------------------------------->
    // 城市道路挖掘许可，同招牌备案
    {
        path: '/excavate-home',
        name: 'excavate-home',
        meta: {
            title: '城市道路掘动行政许可',
            // requireAuth: true,
        },
        component: () => import('@/views/home/citymanagement/beian-excavate/ExcavateHome.vue')
    },
    // // 我要备案
    // {
    //     path: '/my-ggba-apply',
    //     name: 'my-ggba-apply',
    //     component: () => import('../views/home/zp-beian/SubmitGGBABasic.vue')
    // },
    // // 所需资料
    // {
    //     path: '/require-infomation',
    //     name: 'require-infomation',
    //     component: () => import('../views/home/zp-beian/RequireInfomation.vue')
    // },
    // 城市道路掘动行政许可所需资料
    {
        path: '/excavate-need-info',
        name: 'excavate-need-info',
        component: () => import('@/views/home/citymanagement/beian-excavate/ExcavateNeedInfo.vue')
    },
    // 参考图例
    {
        path: '/excavate-legend',
        name: 'excavate-legend',
        component: () => import('@/views/home/citymanagement/beian-excavate/ExcavateLegend.vue')
    },
    // 提交资料
    {
        path: '/excavate-submit-info',
        name: 'excavate-submit-info',
        component: () => import('@/views/home/citymanagement/beian-excavate/ExcavateSubmitInfo.vue')
    },
    // 我的招牌
    {
        path: '/my-excavate-list',
        name: 'my-excavate-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-excavate/MyExcavateApplyList.vue'),
        children: []
    },
    // 我的招牌
    {
        path: '/excavate-apply-details',
        name: 'excavate-apply-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-excavate/ExcavateApplyDetails.vue'),
    },
    //  百姓城管 -> 道路挖掘 <--------------------------------------------

    //  百姓城管 -> 污水排放 -------------------------------------------->
    // 城市道路挖掘许可，同招牌备案
    {
        path: '/emission-home',
        name: 'emission-home',
        meta: {
            title: '城市道路掘动行政许可',
            // requireAuth: true,
        },
        component: () => import('@/views/home/citymanagement/beian-emission/EmissionHome.vue')
    },
    // // 我要备案
    // {
    //     path: '/my-ggba-apply',
    //     name: 'my-ggba-apply',
    //     component: () => import('../views/home/zp-beian/SubmitGGBABasic.vue')
    // },
    // // 所需资料
    // {
    //     path: '/require-infomation',
    //     name: 'require-infomation',
    //     component: () => import('../views/home/zp-beian/RequireInfomation.vue')
    // },
    // 城市道路掘动行政许可所需资料
    {
        path: '/emission-need-info',
        name: 'emission-need-info',
        component: () => import('@/views/home/citymanagement/beian-emission/EmissionNeedInfo.vue')
    },
    // 参考图例
    {
        path: '/emission-legend',
        name: 'emission-legend',
        component: () => import('@/views/home/citymanagement/beian-emission/EmissionLegend.vue')
    },
    // 提交资料
    {
        path: '/emission-submit-info',
        name: 'emission-submit-info',
        component: () => import('@/views/home/citymanagement/beian-emission/EmissionSubmitInfo.vue')
    },
    // 我的招牌
    {
        path: '/my-emission-list',
        name: 'my-emission-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-emission/MyEmissionApplyList.vue'),
        children: []
    },
    // 我的招牌
    {
        path: '/emission-apply-details',
        name: 'emission-apply-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-emission/EmissionApplyDetails.vue'),
    },
    //  百姓城管 -> 污水排放 <--------------------------------------------

    //  我的-> 我的企业
    // 我的企业
    {
        path: '/company-mine',
        name: 'company-mine',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/mine/company-mine/CompanyMine.vue'),
        children: [
            // 企业信息 绑定
            {
                path: '/company-bind',
                name: 'company-bind',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/mine/company-mine/CompanyBind.vue'),
            },
            // 招聘报名情况
            {
                path: '/company-employee-list',
                name: 'company-employee-list',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/mine/company-mine/CompanyEmpployeList.vue'),
            },
            // 政策匹配情况
            {
                path: '/zcpp-info-list',
                name: 'zcpp-info-list',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/mine/company-mine/ZCPPInfoList.vue'),
            },
        ],
    },
    // 招聘报名情况 外部
    {
        path: '/company-employee-list-notify',
        name: 'company-employee-list-notify',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/mine/company-mine/CompanyEmpployeListNotify.vue'),
    },
    // 政策匹配情况详情
    {
        path: '/zzpc-info-details',
        name: 'zzpc-info-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/mine/company-mine/ZCPPInfoDetails.vue'),
    },
    // 未持证残疾人基本信息填报
    {
        path: '/unlicensed-disabled-people-report',
        name: 'unlicensed-disabled-people-report',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/mine/canji/UnlicensedDisabledPeople.vue'),
    },
    // 应聘工作
    {
        path: '/apply-job-record-list',
        name: 'apply-job-record-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/jinghang/ApplyJobRecordList.vue'),
    },
    // 优惠券
    {
        path: '/gonghui-coupons-list',
        name: 'gonghui-coupons-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/goonghui/GonghuiCouponsList.vue'),
    },
    // 核销记录
    {
        path: '/hexiao-record-list',
        name: 'hexiao-record-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/goonghui/HeXiaoRecordList.vue'),
    },
    // 测试页面
    {
        path: '/test-view',
        name: 'test-view',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/TestView.vue'),
    },

    //  百姓城管 -> 占用道路 -------------------------------------------->
    // 占用道路，基本同挖掘道路
    {
        path: '/zhandao-home',
        name: 'zhandao-home',
        meta: {
            title: '占用道路行政许可',
            // requireAuth: true,
        },
        component: () => import('@/views/home/citymanagement/beian-zhandao/ZhandaoHome.vue')
    },
    // 城市道路掘动行政许可所需资料
    {
        path: '/zhandao-need-info',
        name: 'zhandao-need-info',
        component: () => import('@/views/home/citymanagement/beian-zhandao/ZhandaoNeedInfo.vue')
    },
    // 参考图例
    {
        path: '/zhandao-legend',
        name: 'zhandao-legend',
        component: () => import('@/views/home/citymanagement/beian-zhandao/ZhandaoLegend.vue')
    },
    // 提交资料\\
    {
        path: '/zhandao-submit-info',
        name: 'zhandao-submit-info',
        component: () => import('@/views/home/citymanagement/beian-zhandao/ZhandaoSubmitInfo.vue')
    },
    // 我的招牌
    {
        path: '/my-zhandao-list',
        name: 'my-zhandao-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-zhandao/MyZhandaoApplyList.vue'),
        children: []
    },
    // 我的招牌
    {
        path: '/zhandao-apply-details',
        name: 'zhandao-apply-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-zhandao/ZhandaoApplyDetails.vue'),
    },
    //  百姓城管 -> 占道 <--------------------------------------------

    //  百姓城管 -> 管线 -------------------------------------------->
    // 占用道路，基本同挖掘道路
    {
        path: '/guanxian-home',
        name: 'guanxian-home',
        meta: {
            title: '管线设施申请',
            // requireAuth: true,
        },
        component: () => import('@/views/home/citymanagement/beian-guanxian/GuanxianHome.vue')
    },
    // 城市道路掘动行政许可所需资料
    {
        path: '/guanxian-need-info',
        name: 'guanxian-need-info',
        component: () => import('@/views/home/citymanagement/beian-guanxian/GuanxianNeedInfo.vue')
    },
    // 参考图例
    {
        path: '/guanxian-legend',
        name: 'guanxian-legend',
        component: () => import('@/views/home/citymanagement/beian-guanxian/GuanxianLegend.vue')
    },
    // 提交资料\\
    {
        path: '/guanxian-submit-info',
        name: 'guanxian-submit-info',
        component: () => import('@/views/home/citymanagement/beian-guanxian/GuanxianSubmitInfo.vue')
    },
    // 我的招牌
    {
        path: '/my-guanxian-list',
        name: 'my-guanxian-list',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-guanxian/MyGuanxianApplyList.vue'),
        children: []
    },
    // 我的招牌
    {
        path: '/guanxian-apply-details',
        name: 'guanxian-apply-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/citymanagement/beian-guanxian/GuanxianApplyDetails.vue'),
    },
    //  百姓城管 -> 管线 <--------------------------------------------

    // 我的政策
    {
        path: '/my-match-policy',
        name: 'my-match-policy',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-policy/MyMatchPolicy.vue'),
    },
    // 我的政策-详情
    {
        path: '/my-match-policy-details',
        name: 'my-match-policy-details',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-policy/MyMatchPolicyDetails.vue'),
    },
    // 我的政策-原文
    {
        path: '/my-match-policy-origin',
        name: 'my-match-policy-origin',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-policy/MyMatchPolicyOrigin.vue'),
    },

    // 我的通知
    {
        path: '/my-match-notice',
        name: 'my-match-notice',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-notice/MyMatchNotice.vue'),
    },
    // 我的通知-原文
    {
        path: '/my-match-notice-origin',
        name: 'my-match-notice-origin',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-notice/MyMatchNoticeOrigin.vue'),
    },
    // 网格走访
    {
        path: '/grid-interview',
        name: 'grid-interview',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-grid-interview/GridInterview.vue'),
        redirect: '/warm-company-service',
        children: [
            // 暖企服务
            {
                path: '/warm-company-service',
                name: 'warm-company-service',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/home/yingshang/cydn-grid-interview/WarmCompanyService.vue'),
            },
            // 日常走访
            {
                path: '/daily-interview',
                name: 'daily-interview',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/home/yingshang/cydn-grid-interview/DailyInterview.vue'),
            },
        ],
    },
    {
        path: '/policy-introduction',
        name: 'policy-introduction',
        // meta: {
        //     requireAuth: true,
        // },
        component: () => import('@/views/home/yingshang/cydn-grid-interview/PolicyIntroduction.vue'),
    },
    // 走访反馈
    {
        path: '/interview-feedback',
        name: 'interview-feedback',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/cydn-grid-interview/InterviewFeedback.vue'),
    },
    // 政策匹配
    {
        path: '/policy-match',
        name: 'policy-match',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/cydn-grid-interview/PolicyMatch.vue'),
    },
    // 政策匹配-详情
    {
        path: '/policy-match-details',
        name: 'policy-match-details',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/cydn-grid-interview/PolicyDetails.vue'),
    },
    // 企业认证
    {
        path: '/company-authenication',
        name: 'company-authenication',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/mine/company-mine/CompanyAuthenication.vue'),
    },

    // 匹配政策列表 新
    {
        path: '/match-policy-list',
        name: 'match-policy-list',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/MatchPolicyList.vue'),
    },
    // 匹配政策详情
    {
        path: '/suqiu-match-policy-details',
        name: 'suqiu-match-policy-details',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/SuQiuMatchPolicyDetails.vue'),
    },
    // 匹配政策原文
    {
        path: '/suqiu-match-policy-origin',
        name: 'suqiu-match-policy-origin',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/SuQiuMatchPolicyOrigin.vue'),
    },
    // -----------------------------产品展销
    // 产品展销
    {
        path: '/production-exhibit-sale',
        name: 'production-exhibit-sale',
        meta: {
            keepAlive: true,
            requireAuth: true,
        },
        component: () => import('@/views/home/exhibit/ProductionExhibitSale.vue'),
    },
    // 产品展销 详情
    {
        path: '/production-details',
        name: 'production-details',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/exhibit/ProductionDetailsView.vue'),
    },
    // 产品展销 上传
    {
        path: '/production-add',
        name: 'production-add',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/exhibit/ProductionAdd.vue'),
    },
    // 产品展销 我的产品
    {
        path: '/production-uploaded',
        name: 'production-uploaded',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/exhibit/MyUploadedProduction.vue'),
        redirect: '/my-production-list',
        children: [
            // 展示中
            {
                path: '/my-production-list',
                name: 'my-production-list',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/home/exhibit/MyProductionList.vue'),
            },
            // 待审核
            {
                path: '/my-production-wait-list',
                name: 'my-production-wait-list',
                // meta: {
                //     requireAuth: true,
                // },
                component: () => import('@/views/home/exhibit/MyProductionWaitList.vue'),
            },
        ],
    },
    // 惠企政策/惠企通知
    {
        path: '/hqtz',
        name: 'hqtz',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/yingshang/huiqitongzhi.vue'),
    },
    //     ------------------潮河 平安社区
    // 主页
    {
        path: '/main-chaohe',
        name: 'main-chaohe',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MainChaohe.vue'),
        redirect: '/home-safety-park',
        children: [
            // 首页
            {
                path: '/home-safety-park',
                name: 'home-safety-park',
                meta: {
                    keepAlive: true,
                    // requireAuth: true,
                },
                component: () => import('@/views/home/chaohe/grid_operator/HomeSafetyPark.vue'),
            },
            // 我的
            {
                path: '/mine-chaohe',
                name: 'mine-chaohe',
                meta: {
                    // requireAuth: true,
                },
                component: () => import('@/views/home/chaohe/grid_operator/Mine.vue'),
            },
        ]
    },
    // 发布商品
    {
        path: '/goods-send-chaohe',
        name: 'goods-send-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/GoodsSendChaohe.vue'),
    },
    // 发布话题
    {
        path: '/topic-send-chaohe',
        name: 'topic-send-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/TopicSend.vue'),
    },
    // 发布提醒
    {
        path: '/remind-send-chaohe',
        name: 'remind-send-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/RemindSend.vue'),
    },
    // 商品详情
    {
        path: '/goods-details-chaohe',
        name: 'goods-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/GoodsDetails.vue'),
    },
    // 话题详情
    {
        path: '/topic-details-chaohe',
        name: 'topic-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/TopicDetails.vue'),
    },
    // 提醒详情
    {
        path: '/remind-details-chaohe',
        name: 'remind-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/RemindDetails.vue'),
    },
    // 上报历史
    {
        path: '/report-hidden-history',
        name: 'report-hidden-history',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenReportHistory.vue'),
    },
    // 上报历史 详情
    {
        path: '/report-hidden-history-details',
        name: 'report-hidden-history-details',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenDangerReportDetails.vue'),
    },
    // 隐患雷达
    {
        path: '/hidden-danger-radar',
        name: 'hidden-danger-radar',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenDangerRadar.vue'),
    },
    // 问题上报
    {
        path: '/hidden-danger-report',
        name: 'hidden-danger-report',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenDangerReport.vue'),
    },
    // 我的评价
    {
        path: '/hidden-danger-report-my-comment',
        name: 'hidden-danger-report-my-comment',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenDangerReportMyComment.vue'),
    },
    // 去评价
    {
        path: '/hidden-danger-report-comment',
        name: 'hidden-danger-report-comment',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/HiddenDangerReportToComment.vue'),
    },
    // 积分兑换
    {
        path: '/point-exchange-chaohe',
        name: 'point-exchange-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/PointExchange.vue'),
    },
    // 积分管理
    {
      path: '/point-manage-chaohe',
      name: 'point-manage-chaohe',
      meta: {
          keepAlive: true,
        // requireAuth: true,
      },
      component: () => import('@/views/home/chaohe/grid_operator/PointManage.vue'),
    },
    // 积分管理 -  管理端
    {
      path: '/point-manage-admin-chaohe',
      name: 'point-manage-admin-chaohe',
      meta: {
          keepAlive: true,
        // requireAuth: true,
      },
      component: () => import('@/views/home/chaohe/grid_administrator/PointManageAdmin.vue'),
    },
    // 安全警示
    {
        path: '/safety-warning',
        name: 'safety-warning',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/SafetyWarning.vue'),
    },
    // 安全警示 详情
    {
        path: '/safety-warning-details',
        name: 'safety-warning-details',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/SafetyWarningDetails.vue'),
    },
    // 我的商品列表
    {
        path: '/my-goods-list-chaohe',
        name: 'my-goods-list-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyGoodsListChaohe.vue'),
    },
    // 我的商品详情
    {
        path: '/my-goods-details-chaohe',
        name: 'my-goods-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyGoodsDetailsChaohe.vue'),
    },
    // 我的话题列表
    {
        path: '/my-topic-list-chaohe',
        name: 'my-topic-list-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyTopicListChaohe.vue'),
    },
    // 我的话题详情
    {
        path: '/my-topic-details-chaohe',
        name: 'my-topic-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyTopicDetailsChaohe.vue'),
    },
    // 我的提醒列表
    {
        path: '/my-remind-list-chaohe',
        name: 'my-remind-list-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyRemindListChaohe.vue'),
    },
    // 我的提醒详情
    {
        path: '/my-remind-details-chaohe',
        name: 'my-remind-details-chaohe',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_operator/MyRemindDetailsChaohe.vue'),
    },
    // --------------------------------------------
    // 隐患雷达 管理端
    {
        path: '/hidden-danger-radar-admin',
        name: 'hidden-danger-radar-admin',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_administrator/HiddenDangerRadarAdmin.vue'),
    },
    {
        path: '/problem-list',
        name: 'problem-list',
        meta: {
            keepAlive: true,
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_administrator/ProblemList.vue'),
    },
    {
        path: '/problem-acceptance',
        name: 'problem-acceptance',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_administrator/ProblemAcceptance.vue'),
    },
    {
        path: '/problem-handle-details',
        name: 'problem-handle-details',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_administrator/ProblemHandleDetails.vue'),
    },
    // 管理员查看 用户 积分列表
    {
        path: '/user-point-list',
        name: 'user-point-list',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/chaohe/grid_administrator/UserPointList.vue'),
    },
    // 企业模式-专项整治
    {
        path: '/special-rectification',
        name: 'special-rectification',
        meta: {
            // requireAuth: true,
        },
        component: () => import('@/views/home/enterprise-mode/SpecialRectification.vue'),
    },
]

const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    // base: '/shequ',
    routes,
    // scrollBehavior () {
    //     return { x: 0, y: 0 }
    // }

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    // console.log(to,from,'-----------------------------')

    if (Cookies.get('X-Client-Type') == 'app-community') {
        // next()
        // 社区账号

        if (to.path == '/blank-view') {
            router.push({path: '/admin'})
        } else {
            return next()
        }
    } else if (Cookies.get('X-Client-Type') == 'app-resident') {
        localStorage.setItem('isRouteAdmin', 'false')
        // 原来的逻辑
        if (to.meta.requireAuth) {
            // alert(JSON.parse(localStorage.getItem('userInfo')).visitor)
            if (Cookies.get('jk_community_token') && (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).visitor != '1')) {
                next()
                return
            }
            // 加一个弹窗，让用户选择是否同意登录
            Dialog.confirm({
                title: '提示',
                message: '使用用户信息相关功能需要先登录',
            }).then(() => {
                // on close
                jWeixin.miniProgram.navigateTo({url: '/pages/home/home'})
            }).catch(() => {

            });

            // jWeixin.miniProgram.navigateTo
            // router.push({name: 'login', params: {redirect: to.fullPath}})
        } else {
            next()
        }
    } else {
        // Dialog.confirm({
        //     title: '提示bbbb',
        //     message: '使用用户信息相关功能需要先登录',
        // }).then(() => {
        //     // on close
        //     jWeixin.miniProgram.navigateTo({url: '/pages/home/home'})
        // }).catch(()=>{
        //
        // });

        if (to.path == '/blank-view') {
            router.push({path: '/admin'})
        } else {
            return next()
        }

        // next()
    }

    // // 登录界面登录成功之后，会把用户信息保存在会话
    // let token = Cookies.get('jk_community_token')
    // // console.log(token);
    // if (token) {
    //     next()
    // } else {
    //     // console.log(to, from);
    //     if (to.name == 'login') {
    //         return next()
    //     } else {
    //         router.push({path: '/login'})
    //     }
    //
    // }
})

export default router
